document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleria();
  initVariantes();
  initFaq();
  initMarquesina();
  initParallaxHero();
  initCountdown();
  initStickyCompra();
  initAntesDespues();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  function revelarTodos() {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }
  if (!('IntersectionObserver' in window) || document.hidden) {
    revelarTodos();
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
  /* Red de seguridad: si el navegador pausa el observer (pestaña en segundo
     plano, throttling), el contenido no debe quedar invisible para siempre. */
  setTimeout(revelarTodos, 2500);
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var dur = 1200;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var p = Math.min((ts - inicio) / dur, 1);
          var val = fin * (1 - Math.pow(1 - p, 3));
          el.textContent = (Number.isInteger(fin) ? Math.round(val) : val.toFixed(1)).toString();
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        obs.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleria() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-mt-galeria-mini]');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src || !principal) return;
      principal.src = src;
      minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function initVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var grupos = form.querySelectorAll('[data-mt-opcion-grupo]');
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!grupos.length || !dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioComparadoEl = document.querySelector('[data-mt-precio-comparado]');
  var botón = form.querySelector('[data-mt-add-boton]');

  function elegidas() {
    return Array.prototype.map.call(grupos, function (grupo) {
      var activo = grupo.querySelector('.mt-opcion-pill-activa');
      return activo ? activo.getAttribute('data-valor') : null;
    });
  }

  function actualizar() {
    var vals = elegidas();
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === vals[i]; });
    });
    if (!encontrada) return;
    idInput.value = encontrada.id;
    if (precioEl) precioEl.textContent = encontrada.price_formatted;
    if (precioComparadoEl) {
      if (encontrada.compare_at_price_formatted) {
        precioComparadoEl.textContent = encontrada.compare_at_price_formatted;
        precioComparadoEl.style.display = '';
      } else {
        precioComparadoEl.style.display = 'none';
      }
    }
    if (botón) {
      if (encontrada.available) {
        botón.disabled = false;
        botón.setAttribute('data-mt-estado', 'disponible');
      } else {
        botón.disabled = true;
        botón.setAttribute('data-mt-estado', 'agotado');
      }
    }
  }

  grupos.forEach(function (grupo) {
    grupo.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-mt-opcion-valor]');
      if (!boton || !grupo.contains(boton)) return;
      grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (b) {
        b.classList.remove('mt-opcion-pill-activa');
      });
      boton.classList.add('mt-opcion-pill-activa');
      actualizar();
    });
  });
  actualizar();
}

function initCountdown() {
  var relojes = document.querySelectorAll('[data-mt-countdown-reloj]');
  if (!relojes.length) return;
  function actualizar() {
    var ahora = new Date();
    var fin = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), 23, 59, 59);
    var restante = Math.max(0, fin.getTime() - ahora.getTime());
    var h = Math.floor(restante / 3600000);
    var m = Math.floor((restante % 3600000) / 60000);
    var s = Math.floor((restante % 60000) / 1000);
    var texto = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
    relojes.forEach(function (el) { el.textContent = texto; });
  }
  actualizar();
  setInterval(actualizar, 1000);
}

function initStickyCompra() {
  var barra = document.querySelector('[data-mt-sticky-compra]');
  var botonSticky = document.querySelector('[data-mt-sticky-boton]');
  if (!barra || !botonSticky) return;

  var botonReal = document.querySelector('[data-mt-add-boton]');
  var variantId = botonSticky.getAttribute('data-variant-id');

  if (botonReal) {
    /* Página de producto: el botón fijo activa el formulario real. */
    botonSticky.addEventListener('click', function () { botonReal.click(); });

    var precioEl = document.querySelector('[data-mt-precio]');
    var precioSticky = document.querySelector('[data-mt-precio-sticky]');
    if (precioEl && precioSticky && 'MutationObserver' in window) {
      precioSticky.textContent = precioEl.textContent;
      new MutationObserver(function () { precioSticky.textContent = precioEl.textContent; })
        .observe(precioEl, { childList: true, characterData: true, subtree: true });
    }

    botonSticky.disabled = botonReal.disabled;
    botonSticky.textContent = botonReal.textContent.trim();
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        botonSticky.disabled = botonReal.disabled;
        botonSticky.textContent = botonReal.textContent.trim();
      }).observe(botonReal, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    }
  } else if (variantId) {
    /* Otras páginas (ej. inicio): añade directamente al carrito y lleva al carrito. */
    var textoOriginal = botonSticky.textContent;
    botonSticky.addEventListener('click', function () {
      botonSticky.disabled = true;
      botonSticky.textContent = 'Añadiendo…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('No se pudo añadir'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          botonSticky.disabled = false;
          botonSticky.textContent = textoOriginal;
          window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
        });
    });
  }

  var disparador = botonReal || document.querySelector('[data-mt-sticky-trigger]');
  if (disparador && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        barra.classList.toggle('mt-sticky-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-72px 0px 0px 0px' });
    obs.observe(disparador);
  }
}

function initFaq() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      item.closest('[data-mt-faq]').querySelectorAll('[data-mt-faq-item]').forEach(function (i) {
        i.classList.remove('mt-faq-abierto');
      });
      if (!abierto) item.classList.add('mt-faq-abierto');
    });
  });
}

function initMarquesina() {
  var esEscritorio = window.matchMedia('(min-width: 750px)').matches;
  document.querySelectorAll('[data-mt-marquesina]').forEach(function (track) {
    if (!esEscritorio || track.dataset.mtDuplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtDuplicado = '1';
  });
}

function initParallaxHero() {
  var wrap = document.querySelector('[data-mt-hero-parallax]');
  var img = wrap ? wrap.querySelector('.mt-hero-img') : null;
  if (!wrap || !img) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(max-width: 749px)').matches) return;
  var ticking = false;
  function actualizar() {
    var rect = wrap.getBoundingClientRect();
    var centro = rect.top + rect.height / 2;
    var desplazamiento = (window.innerHeight / 2 - centro) * 0.05;
    desplazamiento = Math.max(Math.min(desplazamiento, 22), -22);
    img.style.transform = 'translateY(' + desplazamiento.toFixed(1) + 'px) scale(1.08)';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(actualizar); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', actualizar);
  actualizar();
}

function initAntesDespues() {
  document.querySelectorAll('[data-mt-ad]').forEach(function (wrap) {
    var imgs = wrap.querySelector('.mt-ad-imgs');
    var antesWrap = wrap.querySelector('[data-mt-ad-antes-wrap]');
    var linea = wrap.querySelector('[data-mt-ad-linea]');
    var range = wrap.querySelector('[data-mt-ad-range]');
    if (!imgs || !antesWrap || !linea || !range) return;

    function actualizar(valor) {
      antesWrap.style.clipPath = 'inset(0 ' + (100 - valor) + '% 0 0)';
      linea.style.left = valor + '%';
    }
    actualizar(range.value);
    range.addEventListener('input', function () { actualizar(range.value); });

    var arrastrando = false;
    function moverDesdeEvento(clientX) {
      var rect = imgs.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      range.value = pct;
      actualizar(pct);
    }
    imgs.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      moverDesdeEvento(e.clientX);
    });
    window.addEventListener('pointermove', function (e) {
      if (arrastrando) moverDesdeEvento(e.clientX);
    });
    window.addEventListener('pointerup', function () { arrastrando = false; });
  });
}
